import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'

const STYLES = css`

:host #WLTR_bubblePopup {
  background: #ffffff;
  cursor:default;
  position: absolute;
  width: 224px;
  left: -12px;
  z-index:99999;
  font-family: sans-serif;
  bottom: 120px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #4F5152;
  padding: 12px;
  box-sizing: border-box; 
  box-shadow: 41px -33px 21px rgba(43, 6, 81, 0.03), 23px -18px 18px rgba(43, 6, 81, 0.11), 10px -8px 13px rgba(43, 6, 81, 0.18), 3px -2px 7px rgba(43, 6, 81, 0.21), 0px 0px 0px rgba(43, 6, 81, 0.21);
}

:host #WLTR_bubblePopup:after {
  content: " ";
  display: block;
  position: absolute;
  background: transparent;
  left: 30px;
  bottom: -8px; 
  z-index:99999;  
  width: 0; 
  height: 0; 
  border-left: 10px solid transparent;
  border-right: 10px solid transparent; 
  border-top: 8px solid #ffffff;   
}

:host #WLTR_bubblePopup .WLTR_sigleButtonBox {
  text-align:right;
  padding-top: 12px;
}

:host #WLTR_bubblePopup .WLTR_buttonLink {
  color: #ffffff;
  background: #5900B0;
  border-radius: 900px;
  display: inline-block;
  padding: 8px 14px;
  font-size: 11px;
  line-height: 16px;
  text-decoration: none; 
}

:host #WLTR_bubblePopup .WLTR_closeBubble {
  background: #5900B0;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: block; 
  color:#FFFFFF; 
  line-height: 82px;
  text-align: center;
  margin-left: auto; 
  margin-right: 25px;
  text-decoration: none;
  position: relative;
  top: -24px;
  left: 200px;
}

:host #WLTR_bubblePopup .WLTR_closeBubble:before {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='17px' viewBox='0 0 24 24' width='17px' fill='%23FFFFFF'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3C/svg%3E");
  vertical-align: middle;
  position: relative;
  top: -25px;  
}

:host #WLTR_bubblePopup .WLTR_close {
  position: absolute;  
}

`
@customElement('cp-bubble')
export class Bubble extends LitElement {
    static styles = STYLES

    private _text: Optional<String> = ''
    private _ctaText: Optional<String> = '' 
    private _ctaLink: Optional<String> = '' 

    @property()
    get text() {
        return this._text
    }

    set text(value: Optional<String>) {
        this._text = value
    }

    @property()
    get ctaText() {
        return this._ctaText
    }
    set ctaText(value: Optional<String>) {
        this._ctaText = value
    }

    @property()
    get ctaLink() {
        return this._ctaLink
    }
    set ctaLink(value: Optional<String>) {
        this._ctaLink = value
    }
    
    private _onClick(_: Event) {

      this.style.display = "none";
    }

    protected render() {
        return html`
        <div id="WLTR_bubblePopup">
        <div class="WLTR_close"><a class="WLTR_closeBubble" href="#" @click="${ this._onClick}"></a></div>${ this._text}${ this.ctaLink != undefined ? html`<div class="WLTR_sigleButtonBox"><a href="${this._ctaLink}" class="WLTR_buttonLink" target="_blank">${this._ctaText}</a>` : null }</div>
        <slot></slot>
        </div>
        `;
    }
}


